import { z } from 'zod/v4';

export const DocumentTypeSchema = z.object({
  id: z.string(),
  title: z.string(),
  documentClass: z.enum(['TRANSACTIONAL', 'COMPANY']),
  isDeprecated: z.boolean(),
  impactAreaId: z.string().nullable(),
});

export type DocumentTypeType = z.infer<typeof DocumentTypeSchema>;
